import { ChangeEvent, RefObject } from "react";

interface Props {
  themeUrl: string;
  avatarUrl: string;
  triggerThemeInput: () => void;
  triggerAvatarInput: () => void;
  themeInputRef: RefObject<HTMLInputElement>;
  avatarInputRef: RefObject<HTMLInputElement>;
  handleThemeChange: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
  handleAvatarChange: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
}

export default function ProfileImages({
  themeUrl,
  avatarUrl,
  triggerThemeInput,
  triggerAvatarInput,
  themeInputRef,
  avatarInputRef,
  handleThemeChange,
  handleAvatarChange,
}: Props) {
  return (
    <div className="cabinet_profileeditmodal-left-images">
      <div className="cabinet_profileeditmodal-left-images-theme">
        <img
          src={themeUrl}
          alt="theme"
          className="cabinet_profileeditmodal-left-images-theme-image"
          onClick={triggerThemeInput}
          style={{ cursor: "pointer" }}
        />
        <input
          type="file"
          ref={themeInputRef}
          onChange={handleThemeChange}
          accept="image/*"
          style={{ display: "none" }}
        />
        <img
          src="./modal/themeHover.svg"
          alt=""
          className="cabinet_profileeditmodal-left-images-theme-hover"
          onClick={triggerThemeInput}
        />
      </div>

      <div className="cabinet_profileeditmodal-left-images-avatar">
        <img
          src={avatarUrl}
          alt="avatar"
          className="cabinet_profileeditmodal-left-images-avatar-image"
          onClick={triggerAvatarInput}
          style={{ cursor: "pointer" }}
        />
        <input
          type="file"
          ref={avatarInputRef}
          onChange={handleAvatarChange}
          accept="image/*"
          style={{ display: "none" }}
        />
        <img
          src="./modal/avatarHover.svg"
          alt=""
          className="cabinet_profileeditmodal-left-images-avatar-hover"
          onClick={triggerAvatarInput}
        />
      </div>
    </div>
  );
}
